export const courseNameLegacyTagRE = /(.*) \| ([A-Z]{2,3}\.\d{3}\.\d\.LMS)$/

export const dateIsoUtcRE = /^(-?(?:[1-9][0-9]*)?[0-9]{4})-(1[0-2]|0[1-9])-(3[01]|0[1-9]|[12][0-9])[T\ ](2[0-3]|[01][0-9]):([0-5][0-9]):([0-5][0-9])(\.[0-9]+)?Z?$/i
export const dateSqlUtcRE = /^(\d{1,2}\/?){2}\d{2,4}(\ \d{1,2}:(\d{2}:?){2} [AP]M)?$/

export function dateReviver(k: string, v: any): any {
  if(typeof v === 'string') {
    const matches = dateIsoUtcRE.exec(v)
      || dateSqlUtcRE.exec(v)
    if(matches) {
      return new Date(v)
    }
  }
  return v
}

export const mutateKeys_lowercaseFirstLetter = obj => {
  return Object.keys(obj).reduce((acc, k) => {
    const nextKey = k.split('')
    nextKey[0] = nextKey[0].toLowerCase()
    acc[nextKey.join('')] = obj[k]
    return acc
  }, {})
}

declare var process : {
  env: {
    LMS_ROOT: string
    LMS_ROOT_PREFIXEXCEPTION: string
  }
}

export function prefixUrl(url: string): string {
  const exceptions = process.env.LMS_ROOT_PREFIXEXCEPTION.split(',').map(exc => new RegExp(exc, 'i'))
  if(exceptions.some(exc => exc.test(url))) {
    return url
  }
  const root = process.env.LMS_ROOT
    .replace(/\\$/, '')
  return `${root}${url}`
}


export function sortByArrayIndex(orderArray: Array<any>): (a: any, b: any) => number {
  return (a, b) => {
    const ia = orderArray.indexOf(a)
    const ib = orderArray.indexOf(b)
    if(ia === -1 && ib === -1) return 0
      if(ia === -1 && ib > -1) return 1
        if(ia > -1 && ib === -1) return -1
          const va = orderArray.length - ia
    const vb = orderArray.length - ib
    return vb - va
  }
}
